module.exports = __webpack_public_path__ + "img/symbol_0.4a9fa67f.png";